// Add here the endpoints for MS Graph API services you would like to use.
export const GRAPH_CONFIG = {
  GRAPH_ME_ENDPT: 'https://graph.microsoft.com/v1.0/me',
  GRAPH_MAIL_ENDPT: 'https://graph.microsoft.com/v1.0/me/messages',
}
